const indexItems = [
  { name: '明星八卦', count: '1.2万篇', icon: 'ri-star-line', color: 'primary' },
  { name: '综艺娱乐', count: '9865篇', icon: 'ri-tv-line', color: 'accent' },
  { name: '影视资讯', count: '8723篇', icon: 'ri-film-line', color: 'primary' },
  { name: '音乐动态', count: '7654篇', icon: 'ri-music-2-line', color: 'accent' },
  { name: '时尚潮流', count: '6543篇', icon: 'ri-shirt-line', color: 'primary' },
  { name: '网络热议', count: '5876篇', icon: 'ri-fire-line', color: 'accent' },
  { name: '直播热点', count: '4321篇', icon: 'ri-live-line', color: 'primary' },
  { name: '体育娱乐', count: '3987篇', icon: 'ri-basketball-line', color: 'accent' },
  { name: '网红达人', count: '3456篇', icon: 'ri-user-star-line', color: 'primary' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            吃瓜合集
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[500px] mx-auto">
            按主题分类浏览，快速找到你感兴趣的吃瓜内容
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4 md:gap-5 max-w-[1000px] mx-auto">
          {indexItems.map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-100 rounded-lg p-5 border border-background-200/60 transition-all duration-300 hover:border-primary-200 cursor-pointer flex items-center gap-4"
            >
              <div
                className={`w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0 ${
                  item.color === 'primary' ? 'bg-primary-50' : 'bg-accent-50'
                }`}
              >
                <i
                  className={`${item.icon} text-lg ${
                    item.color === 'primary' ? 'text-primary-500' : 'text-accent-500'
                  }`}
                ></i>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm md:text-base font-bold text-foreground-900 mb-0.5 whitespace-nowrap">
                  {item.name}
                </p>
                <p className="text-xs text-foreground-400">{item.count}</p>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-primary-500 transition-colors flex-shrink-0"></i>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}